import { English } from '../lang/en';
import { Spanish } from '../lang/es';
import { Portuguese } from '../lang/pt';
import { useUserDataStore } from '../newStore/userDataStore';
import { LangParam, LangTree } from '../types';
import { useFeatureFlags } from './useFeatureFlags';


export function useLanguage() {

  const { checkFlag } = useFeatureFlags();

  const langDict: Record<LangParam, LangTree> = { en: English, es: Spanish, pt: Portuguese };

  const { lang } = useUserDataStore();

  if (lang === 'es') {
    const isTicketsFlagActive = checkFlag('ChangeIssuesToTickets');
    
    let stringLang = JSON.stringify(langDict[lang]);
    if (isTicketsFlagActive) {
      stringLang = stringLang
        .replaceAll('{{finding_label}}', 'ticket')
        .replaceAll('{{finding_label_cap}}', 'Ticket');
    } else {
      stringLang = stringLang
        .replaceAll('{{finding_label}}', 'hallazgo')
        .replaceAll('{{finding_label_cap}}', 'Hallazgo');
    }
  return JSON.parse(stringLang) as LangTree;
}

return langDict[lang];
}
